import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { ExecutiveOverviewResponse } from "../../apis/ticketLifecycleApi";

interface ExecutiveOverviewProps {
  data: ExecutiveOverviewResponse;
}

const StatCard: React.FC<{ label: string; value: number }> = ({ label, value }) => (
  <Card sx={{ flex: 1, minWidth: 140, boxShadow: 2 }}>
    <CardContent>
      <Typography variant="h4" fontWeight={700} color="primary">
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </CardContent>
  </Card>
);

const ExecutiveOverview: React.FC<ExecutiveOverviewProps> = ({ data }) => {
  return (
    <Box>
      <Typography variant="h6" fontWeight={700} gutterBottom>
        Executive Overview
      </Typography>
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <StatCard label="Total Needs Attention" value={data.total_stale} />
        <StatCard label="Assigned" value={data.assigned_stale} />
        <StatCard label="Unassigned" value={data.unassigned_stale} />
      </Box>
    </Box>
  );
};

export default ExecutiveOverview;
